import { IRouteStore } from '../stores/RouteStore';
import { scrollToTop } from '../util/ScrollUtils';

export class RouteService {
  constructor(private routeStore: IRouteStore) {}

  public createUrl(pathWithoutLanguage: string): string {
    return this.routeStore.pageLanguageUrlPath + pathWithoutLanguage;
  }

  public navigateLocal(pathWithoutLanguage: string): void {
    this.routeStore.push(this.createUrl(pathWithoutLanguage));
    scrollToTop();
  }

  public createAbsoluteUrl(pathWithoutLanguageAndSegment: string): string {
    return window.location.origin + this.createUrl(pathWithoutLanguageAndSegment);
  }

  public navigateToInvoicePage(): void {
    this.navigateLocal('/arved');
  }

  public navigateToPaymentHistoryPage(): void {
    this.navigateLocal('/arved/maksete-ajalugu');
  }
}
